module.exports = __webpack_public_path__ + "img/logo.8fe5e281.png";